import { Component } from 'src/utils';
import subHeaderImg from './../../../images/banner-image.jpg';
import subHeaderImgDesktop from './../../../images/banner-image-desktop.jpg';
import logo from './../../../images/logo-s.png';
import logoOutline from './../../../images/logo.png';
import template from './login.html';
import info from './../../../images/question.png';
@Component({
  controllerAs: 'login',
  template
})

export default class LoginContainer {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    '$cookies',
    'spinnerService',
    'authService',
    'toaster',
    '$window',
    'orderService',
    '$rootScope'
  ];

  constructor($scope, $ngRedux, $state, $stateParams, $cookies, $spinner, authService, $toaster, $window, $order, $rootScope) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$cookies = $cookies;
    this.$state = $state;
    this.toaster = $toaster;
    this.storeName = $stateParams.storeName;
    this.authService = authService;
    this.subHeaderImg = subHeaderImg;
    this.subHeaderImgDesktop = subHeaderImgDesktop;
    this.logo = logo;
    this.logoOutline = logoOutline;
    this.$window = $window;
    this.info = info;
    this.$spinner=$spinner;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;

    this.$order = $order;
    if ($stateParams.storeName) {
      this.$spinner.show('appSpinner');
      authService.getStoreDetail($stateParams.storeName)
          .finally(() => $spinner.hide('appSpinner') );
    }
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      store: state.auth.storeDetail
    };
  }

  isScreenSmall() {
    if (this.$window.innerHeight < 300) return true;
  }

  submit1(form) {
    if (form.$invalid) {
      return;
    }
    form.error = {};
    // if (this.email === 'test@gmail.com' && this.password === 'password') {
    //   try {
    //     sessionStorage.setItem('oauth', 'qwertyuiop');
    //   }
    //   catch (e) {
    //     this.$cookies.put('oauth', 'qwertyuiop');
    //   }
    //   this.$state.go('home');
    // }
    this.authService.registerLogin({
      email: this.email,
      password: this.password
    })
    .then(
      success => {
        //  console.log('success', success);
        const profile = success.data.user;
        //  console.log('profile', profile);
        let guestCart = this.authService.getGuestCart();
        let subscription = this.authService.getSubscriptionId();
        if (!profile.shippingAddressLine1 || !profile.shippingState || 
          !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry || 
          !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode) {
          this.authService.doGuestLogout();
          this.toaster.pop('success', 'You need to complete your Profile');
          this.$state.go('profile.edit');
        }
        else if (subscription)
           {
           this.authService.resetSubscriptionCart();
           this.$state.go('subscription-detail',{subscriptionId:subscription.id,option:'edit'});
        }
        else {
          // if(this.authService.getGuestStoreDetail().storeId != profile.store.storeId) {
          //   this.authService.doGuestLogout();
          //   this.authService.removeGuestCart();
          //   this.redirectUsertoStore(success.data);
          //   this.$window.location.href = '/'+ profile.store.storeURLName;
          //   return;
          // }
            if (guestCart) {
            if (guestCart.isDscCard) {
              this.$order.getCartDetail()
              .then(success => 
                {
                this.detail = success.data;
                  if(this.isDscAddedinCart()){
                    this.authService.doGuestLogout();
                    this.$state.go('cart');
                  }
                  else {
                  this.$order.buyDscMembership()
                      .then(() => {
                        this.authService.doGuestLogout();
                        this.$state.go('cart');
                      });
                    }
                })
              .catch(err => {
                this.$order.buyDscMembership()
                  .then(() => {
                    this.authService.doGuestLogout();
                    this.$state.go('cart');
                  });
              });
            } else  if (guestCart.isGiftCard) {
              this.$order.getCartDetail()
              .then(success => 
                {
                this.detail = success.data;
               
                  this.$order.buyGiftCard(guestCart.quantity,guestCart.masterProductId)
                      .then(() => {
                        this.authService.doGuestLogout();
                        this.authService.removeGuestCart();
                        this.$state.go('cart');
                      });
                   
                })
              .catch(err => {
                this.$order.buyGiftCard(guestCart.quantity,guestCart.masterCode)
                  .then(() => {
                    this.authService.doGuestLogout();
                    this.authService.removeGuestCart();
                    this.$state.go('cart');
                  });
              });
            }
            else {
              this.$window.location.href = '//' + guestCart.categoryId + '/sub-category/' + guestCart.subCategoryId + '/product/' + guestCart.masterProductId + '/detail';
            }
          }
          else {
           
            this.$state.go('home');
            this.redirectUsertoStore(success.data);
           // this.$window.location.href ='/'+this.storeName;
            this.authService.doGuestLogout();
          }
        }
      },
      error => {
        //  console.log('error', error);
        if (error.data.errorCode === 621) {
          this.noEmailError = true;
          this.$state.go('inactive');
        }
        else {
          this.noEmailError = false;
          form.error = error.data;
        }
      });
  }





  // 
  submit(form) {
    // console.log('form',form);
    if (form.$invalid) {
      return;
    }
    form.error = {};
    // if (this.email === 'test@gmail.com' && this.password === 'password') {
    //   try {
    //     sessionStorage.setItem('oauth', 'qwertyuiop');
    //   }
    //   catch (e) {
    //     this.$cookies.put('oauth', 'qwertyuiop');
    //   }
    //   this.$state.go('home');
    // }
    this.$spinner.show('appSpinner');
    this.authService.registerLogin({
          email: this.email,
          password: this.password
        })
        .then(
            success => {
      //  console.log('success', success);
      // if(success.data.dscPop){
      //   this.dscPopUp(success.data.dscPop);
      // }
      const profile = success.data.user;
    //  console.log('profile', profile);
    this.$spinner.hide('appSpinner');
    let guestCart = this.authService.getGuestCart();
    let subscription = this.authService.getSubscriptionId();
    if (!profile.shippingAddressLine1 || !profile.shippingState ||
        !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry ||
        !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode) {
      this.authService.doGuestLogout();
      // this.$rootScope.$emit('onLoginSuccess');
      this.toaster.pop('success', 'You need to complete your Profile');
      this.$state.go('profile.edit');
    }
    else if (subscription)
    {
      this.authService.resetSubscriptionCart();
      this.$state.go('subscription-detail',{subscriptionId:subscription.id,option:'edit'});
    }
    else {
      // If store not matched with guest login then redirect to home
      var store = this.authService.getGuestStoreDetail();
      console.log(this.$stateParams);
       if(store.storeId != profile.store.storeId) {
        this.authService.doGuestLogout();
        this.authService.removeGuestCart();
        // this.$rootScope.$emit('onLoginSuccess');
         if(this.$stateParams.productId) {
        //   this.$state.go('product.detail', {
        //     categoryId: this.$stateParams.categoryId, 
        //     subCategoryId: this.$stateParams.subCategoryId, 
        //     productId: this.$stateParams.productId,
        //     storeName: profile.store.storeURLName
        //    });

       this.$window.location.href = '/'+profile.store.storeURLName+ '/' +
       this.$stateParams.categoryId + '/'+ this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
        } else{
          this.$window.location.href = '/'+ profile.store.storeURLName;
          return;
        }
      //   this.redirectUsertoStore(success.data);
      //   // this.$window.location.href = '/'+ profile.store.storeURLName;
      //  //  return;
      }

      if (guestCart) {

        if(store.storeId != profile.store.storeId) {
          
          this.authService.removeGuestCart();
        }
        if (guestCart.isDscCard) {
            this.$spinner.show('appSpinner');
            this.$window.scrollTo(0, 0);
            this.$order.getCartDetail()
            .then(success => 
              {
                this.detail = success.data;
                if(this.isDscAddedinCart()){
                  this.authService.doGuestLogout();
                  // this.$rootScope.$emit('onLoginSuccess');
                  this.$state.go('cart');
                }
                else {
                    this.$order.buyDscMembership()
                        .then(() => {
                      this.authService.doGuestLogout();
                    // this.$rootScope.$emit('onLoginSuccess');
                    this.$state.go('cart');
                  });
                }
                this.$spinner.hide('appSpinner');
              })
              .catch(err => {
                    this.$order.buyDscMembership()
                        .then(() => {
                    this.authService.doGuestLogout();
                    // this.$rootScope.$emit('onLoginSuccess');
                    this.$state.go('cart');
                        });
              });
        }
        else if (guestCart.isGiftCard) {
          this.$spinner.show('appSpinner');
          this.$window.scrollTo(0, 0);
          this.$order.getCartDetail()
          .then(success => 
            {
              this.detail = success.data;
          
              this.$order.buyGiftCard(guestCart.quantity,guestCart.masterProductId)
                      .then(() => {
                    this.authService.doGuestLogout();
                    this.authService.removeGuestCart();
                  this.$rootScope.$emit('onLoginSuccess');
                  this.$state.go('cart');
                });
             
              this.$spinner.hide('appSpinner');
            })
            .catch(err => {
              this.$order.buyGiftCard(guestCart.quantity,guestCart.masterProductId)
                      .then(() => {
                  this.authService.doGuestLogout();
                  this.authService.removeGuestCart();
                  this.$rootScope.$emit('onLoginSuccess');
                  this.$state.go('cart');
                      });
            });
      }

        else {
          this.authService.doGuestLogout();
          this.$rootScope.$emit('onLoginSuccess');
          // this.$window.location.href = 'order/category//' + guestCart.categoryId + '/sub-category/' + guestCart.subCategoryId + '/product/' + guestCart.masterProductId + '/detail';
        }
      }
      else {
        this.authService.doGuestLogout();
        this.redirectUsertoStore(success.data);
        if(this.$stateParams.productId) {
  
         this.$window.location.href = '/'+profile.store.storeURLName+ '/' +
         this.$stateParams.categoryId + '/'+ this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
          } else{
            this.$window.location.href = '/'+ profile.store.storeURLName;
            return;
          }
      }
    }
    // this.$window.location.reload(); 
  },
    error => {
      //  console.log('error', error);
      this.$spinner.hide('appSpinner');
      if (error.data.errorCode === 621) {
        this.noEmailError = true;
        this.$state.go('inactive');
      }
      else {
        this.noEmailError = false;
        form.error = error.data;
      }
    });
  }
  // 

  // redirectUsertoStore(userData) {
  //   console.log("UserData : ", userData);
  //   this.$auth.getAllStores();
  // }

  redirectUsertoStore(userData) {
    var $ctrl;
    $ctrl = this;
    if(this.isDscMember(userData)){
      // this.$window.location.href = '/'+ userData.user.store.storeURLName;
      return;
      // this.authService.getAllStores();
    } else  {
      var isDsc = false;
      this.authService.getAllStores().then(success => {
        console.log(success.data);
        angular.forEach(success.data, function(store) { 
          console.log(store);
          if(store.dscId == 'C') {
            isDsc = true;
          }
        });
        if(isDsc){
          this.$window.location.href = '/dashboard/profile/user';
        }
        else {
        //  this.$window.location.href = '/'+ userData.user.store.storeURLName;
          return;
        }
      });
    }
    // this.authService.getAllStores();
  }

  isDscMember(profile) {
    if (!profile.user.customer) return false;
    return profile.user.customer.dscId === 'C' && new Date() <= new Date(profile.user.customer.dscExpireDate);
  }

  isDscButExpired(profile) {
    if (!profile.customer) return false;
    return profile.customer.dscId === 'C' && new Date() > new Date(profile.customer.dscExpireDate);
  }

  
  doGuestLogin() {
    let store = {};
    store.storeName = this.storeName;
    store.storeId = this.store.storeId;
    this.authService.doGuestLogin(store);
    this.$window.location.href ='/'+this.storeName;
  }

  doGuestLogout() {
    try {
      sessionStorage.removeItem('browseAsGuest');
    }
    catch (e) {
      this.$cookies.remove('browseAsGuest');
    }

  }

  isDscAddedinCart(){
    return this.detail.cartItems.some(function (cartItem) {
      return cartItem.item.storeItemCode === 'C';
    });
  }

  togglePassword(passwordIdTag,togglei) {
    var x = document.getElementById(passwordIdTag);
    var y = document.getElementById(togglei);
      console.log("Password tag ", x);
    if (x.type === "password") {
      x.type = "text";
      y.classList.remove('fa-eye-slash');
      y.classList.add('fa-eye');
    } else {
      x.type = "password";
      y.classList.remove('fa-eye');
      y.classList.add('fa-eye-slash');
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.js